import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useAccess } from "../hooks/useAccess";
import { FetchError } from "../errors/FetchError";
import AccountProfileSection from "../components/account/AccountProfileSection";
import AccountStandingSection from "../components/account/AccountStandingSection";
import AccountPlanSection from "../components/account/AccountPlanSection";
import AccountPasswordSection from "../components/account/AccountPasswordSection";
import AccountDangerZone from "../components/account/AccountDangerZone";
import "../App.css";

export default function AccountPage() {
  const { user, authLoading } = useAuth();
  const { profile, access, standing, loading: accessLoading, error: accessError, retry } = useAccess();
  const isLoading = authLoading || accessLoading;

  return (
    <section className="arena-bg">
      <div className="page-heading">
        <h2 className="page-title">Account</h2>
        <p className="page-sub">Manage your profile and preferences</p>
      </div>
      {isLoading ? (
        // Mirrors the real .account-page shape below (profile row, paired
        // Standing/Plan cards, the Account + Security groups, Danger Zone)
        // instead of the battle-card grid skeleton Trending/History use —
        // this page's content isn't a card grid, so that one didn't preview
        // the actual layout and caused a visible shift once real content
        // loaded in.
        <div className="account-page">
          <div className="account-skeleton-profile">
            <div className="account-skeleton-avatar skeleton" />
            <div className="account-skeleton-lines">
              <div className="account-skeleton-line account-skeleton-line--title skeleton" />
              <div className="account-skeleton-line account-skeleton-line--sub skeleton" />
            </div>
          </div>
          <div className="account-skeleton-status-row">
            <div className="account-skeleton-standing skeleton" />
            <div className="account-skeleton-plan skeleton" />
          </div>
          <div className="account-skeleton-group skeleton" />
          <div className="account-skeleton-group skeleton" />
          <div className="account-skeleton-danger skeleton" />
        </div>
      ) : !user ? (
        <div className="history-guest">
          <h3 className="history-guest-title">Manage Your Account</h3>
          <p className="history-guest-sub">Sign in to view and manage your account.</p>
          <button
            className="fight-btn"
            style={{ maxWidth: 260 }}
            onClick={() => window.dispatchEvent(new CustomEvent("auth:open"))}
          >
            Sign In
          </button>
        </div>
      ) : accessError ? (
        <FetchError message="Couldn't load your account." onRetry={retry} />
      ) : (
        <div className="account-page">
          <AccountProfileSection user={user} profile={profile} />
          <div className="account-status-row">
            <AccountStandingSection standing={standing} />
            <AccountPlanSection access={access} />
          </div>
          <div className="account-group">
            <h4 className="account-group-label">Account</h4>
            <Link className="account-group-row" to="/history">
              <span>Battle History</span>
              <span className="account-row-chevron">›</span>
            </Link>
          </div>
          <AccountPasswordSection user={user} />
          <AccountDangerZone user={user} />
        </div>
      )}
    </section>
  );
}
